import { get } from 'lodash'
import defaultConfig from './defaultConfig'
import dev from './dev'
import uat from './uat'
import prod from './prod'
import research from './research'

const configMapper = {
  dev,
  uat,
  prod,
  research
}

const ADMIN_PROD_HOST = 'admin.magnifi.com'

function isAdminProductionHost() {
  if (typeof window === 'undefined') {
    return false
  }
  return window.location.hostname.replace(/^www\./, '') === ADMIN_PROD_HOST
}

function buildConfig() {
  const envName =
    get(process.env, 'REACT_APP_ENV', '').trim() ||
    (process.env.NODE_ENV === 'production' ? 'prod' : 'dev')

  const merged = {
    ...defaultConfig,
    ...configMapper[envName]
  }

  if (isAdminProductionHost()) {
    return { ...merged, ...prod }
  }

  return merged
}

const config = buildConfig()

export function getAdminApiBase() {
  const base = config.adminBaseUrl
  if (!base || typeof base !== 'string') {
    throw new Error(
      'Missing adminBaseUrl in app config. Use REACT_APP_ENV=prod for production builds.'
    )
  }
  return base.replace(/\/$/, '')
}

export default config
